import { withStyles, createStyles } from '@material-ui/core/styles';
import Warning from '@material-ui/icons/Warning';
import React from 'react';

interface IProps {
  type: string;
  pixels: any;
  classes: any;
}

const styles = () =>
  createStyles({
    root: {
      padding: 10,
      color: '#fff',
      backgroundColor: '#3498db',
      borderRadius: 2,
      marginBottom: 20,
      display: 'flex',
      alignItems: 'center',
      '& div:nth-child(1)': {
        marginRight: 10,
      },
    },
    tags: {
      backgroundColor: '#2980b9',
      borderRadius: 2,
      padding: 3,
      textTransform: 'capitalize',
    },
  });

const TagmanagerAlert = withStyles(styles)((props: IProps) => {
  const { classes, type, pixels } = props;

  if (type === 'tagmanager' && pixels.filter((t: any) => t.type !== 'tagmanager').length > 0) {
    return (
      <div className={classes.root}>
        <div>
          <Warning />
        </div>
        <div>
          Você já possuí o{' '}
          <span className={classes.tags}>
            {pixels
              .filter((item: any) => item.type !== 'tagmanager')
              .map((item: any) => item.type)
              .join(', ')}
          </span>
          , ao instalar o<span className={classes.tags}>Google Tag Manager</span> você pode causar duplicidade de pixels. Você tem certeza que sabe o
          que está fazendo?
        </div>
      </div>
    );
  }

  if (type !== 'tagmanager' && pixels.find((t: any) => t.type === 'tagmanager')) {
    return (
      <div className={classes.root}>
        <div>
          <Warning />
        </div>
        <div>
          Você já possuí o <span className={classes.tags}>Google Tag Manager</span> instalado, ao instalar o{' '}
          <span className={classes.tags}>{type}</span> você pode causar duplicidade de pixels. Você tem certeza que sabe o que está fazendo?
        </div>
      </div>
    );
  }

  return null;
});

export default TagmanagerAlert;
